import "./Header.css";

export default function Header({ user, onLogout }) {
  const today = new Date().toLocaleDateString("en-US", {
    weekday: "long",
    month: "short",
    day: "numeric",
    year: "numeric",
  });

  return (
    <div className="bms_header">
      <div className="bms_navbar">
        <div className="bms_brand">
          <span>
            [<b>B</b>its <b>M</b>anagement <b>S</b>ystem]
          </span>
        </div>
        <div className="bms_nav_controls">
          <button className="bms_logout_btn" onClick={onLogout}>
            Logout
          </button>
        </div>
      </div>
      <div className="bms_welcome_bar">
        <span>
          Welcome <b>{user?.USER_NAME || ""}</b> | Currently you are in Network: All Network
        </span>
        <span>{today}</span>
      </div>
    </div>
  );
}
